import React, { useState, useEffect } from "react";
import {
  EmailRounded,
  PhoneRounded,
  ContentCopyOutlined,
  KeyboardBackspaceRounded,
  Search,
} from "@mui/icons-material";
import {
  Avatar,
  List,
  Stack,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  ListItemButton,
  Paper,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Toolbar,
  Button,
  TextField,
  InputBase,
  IconButton, // Import TextField for input area
  Alert,
} from "@mui/material";
import { toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../redux/selector";
import LinkedInImage from "../images/linkedin_3536505.png";
import Key from "../../clientVariables.json";
import CachedIcon from "@mui/icons-material/Cached";
import VerifiedIcon from '@mui/icons-material/Verified';

const InterestedJobsRecruiterDetails = () => {
  const dispatch = useDispatch();
  const { selectedCandidate } = useSelector(appSelector);
  const { selectedJob, selectedSubmission, jobDetails } =
    useSelector(appSelector);
  const [copied, setCopied] = useState(false);
  const [highlighted, setHighlighted] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [offset, setOffset] = useState(0);
  const [selectedContact, setSelectedContact] = useState(null);
  const [message, setMessage] = useState(""); // State for message input

  const [isSearching, setIsSearching] = useState(false); //search
  const [searchQuery, setSearchQuery] = useState("");

  const theme = useTheme();
  const isMobileSmall = useMediaQuery("(max-width: 479px)");
  const isMobileLarge = useMediaQuery(
    "(min-width: 480px) and (max-width: 767px)"
  );
  const isTabletSmall = useMediaQuery(
    "(min-width: 768px) and (max-width: 991px)"
  );
  const isTabletLarge = useMediaQuery(
    "(min-width: 992px) and (max-width: 1199px)"
  );
  const isDesktopXS = useMediaQuery(
    "(min-width: 992px) and (max-width: 1199px)"
  );
  const isDesktopSmall = useMediaQuery(
    "(min-width: 1200px) and (max-width: 1439px)"
  );
  const isDesktopMedium = useMediaQuery(
    "(min-width: 1440px) and (max-width: 1919px)"
  );
  const isDesktopLarge = useMediaQuery("(min-width: 1920px)");

  const handleSearchClick = () => {
    setIsSearching(true);
  };

  const handleCloseClick = () => {
    setIsSearching(false);
    setSearchQuery("");
  };

  const handleCopy = (email) => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000); // Reset color after 2 seconds
    });
  };

  const toggleHighlight = () => {
    setHighlighted(!highlighted);
  };

  // write hello wolrd program

  const getApolloContacts = () => {
    fetch("https://apps.jobsnprofiles.com/contacts/insert_apollo_contacts", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        domain_name: selectedJob?.email_id?.split("@")[1],
        company_id: selectedJob?.company_id,
      }),
    })
      .then((response) => response.json())
      .then((resdata) => {
        if (resdata.success === 1) {
          // setContacts(resdata?.data?.apolloContacts)
        } else {
          console.error("Unexpected response data:", resdata);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const fetchCompanyContacts = () => {
    fetch(`${Key.domain_crm}/company/get_Company_Contacts`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        page: offset,
        company_id: selectedJob?.company_id,
      }),
    })
      .then((response) => response.json())
      .then((resdata) => {
        if (resdata.success === 1) {
          //getApolloContacts();
          setContacts(resdata?.data?.companyContacts);
        } else {
          console.error("Unexpected response data:", resdata);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchCompanyContacts();
  }, [selectedJob, selectedCandidate]);
  useEffect(() => {
    setSelectedContact(null);
  }, [selectedCandidate]);

  const sendMessage = () => {
    // Implement sending logic here
    // Optionally clear the message input after sending
    setMessage("");
  };
  const handleClick = () => {
    if (
      jobDetails?.contact_linkedin_url !== null &&
      jobDetails?.contact_linkedin_url !== undefined &&
      jobDetails?.contact_linkedin_url !== ""
    ) {
      let url = jobDetails?.contact_linkedin_url;
      if (!url?.startsWith("http://") && !url?.startsWith("https://")) {
        url = "https://" + url;
      }
      window.open(url, "_blank", "noopener noreferrer");
    } else {
      let msg = "Please upload LinkedinUrL";
      toast(
        <Alert variant="filled" severity="warning">
          {msg}
        </Alert>
      );
      toast.warning(msg, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  // Filter contacts based on search query
  const filteredContacts = contacts?.filter((contact) =>
    contact.EMP_CONTACT_NAME.toLowerCase().startsWith(searchQuery.toLowerCase())
  );
  const TRUTHY_CONTACT_VALUES = [1, true, '1']
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Box
          sx={{
            maxHeight: window.innerHeight - 150,
            overflowY: "scroll",
            position: "relative",
          }}
        >
          {selectedJob &&
            Object.keys(selectedJob)?.length !== 0 &&
            selectedJob?.contact_name ? (
            <Card sx={{ boxShadow: "none", borderRadius: "8px", padding: 0 }}>
              <CardContent sx={{ p: 0 }}>
                <Box
                  sx={{
                    position: "relative",
                    padding: "4px",
                    width: "100%",
                    height: "70px",
                  }}
                >
                  <Box sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        borderLeft: "6px solid rgba(64, 104, 130, 0.8)",
                        borderTop: "2px solid rgba(64, 104, 130, 0.8)",
                        borderBottom: "2px solid rgba(64, 104, 130, 0.8)",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          borderLeft: "4px solid #fff",
                          borderTop: "1px solid #fff",
                          borderBottom: "1px solid #fff",
                          borderRadius: "50%",
                        }}
                      >
                        <Avatar src="" sx={{ height: 60, width: 60 }} />
                      </Box>
                    </Box>
                  </Box>
                  {selectedJob?.contactphone !== "N/A" && (
                    <Box
                      sx={{
                        position: "absolute",
                        left: "115px",
                        top: "15px",
                        ".phone-text": {
                          margin: 0,
                          fontSize: "11px",
                          color: "rgba(0,0,0,0.7)",
                          fontWeight: 500,
                          cursor: "pointer",
                          textTransform: "lowercase",
                        },
                        "&:hover": {
                          ".phone-text": {
                            color: "#406882",
                            textDecoration: "underline",
                          },
                        },
                      }}
                    >
                      {selectedJob?.contactphone !== "" &&
                        selectedJob?.contactphone !== null &&
                        selectedJob?.contactphone !== undefined && (
                          <Typography
                            variant="button"
                            paragraph
                            className="phone-text"
                          >
                            <PhoneRounded
                              sx={{ height: "12px", width: "12px", mr: "3px" }}
                            />
                            {selectedJob?.contactphone}
                          </Typography>
                        )}
                    </Box>
                  )}
                  <Box
                    sx={{
                      position: "absolute",
                      right: "2px",
                      top: "10px",
                      ".email-text": {
                        margin: 0,
                        fontSize: "10px",
                        color: copied ? "#406882" : "rgba(0,0,0,0.7)", // Change color when copied
                        fontWeight: 600,
                        cursor: "pointer",
                        textTransform: "lowercase",
                      },
                      "&:hover": {
                        ".email-text": {
                          color: "#406882",
                          textDecoration: "underline",
                        },
                      },
                    }}
                  >
                    <Typography
                      variant="button"
                      paragraph
                      className={`email-text ${highlighted ? "highlighted" : ""
                        }`}
                      onClick={() => handleCopy(selectedJob?.email_id)}
                    >
                      <Tooltip title={copied ? "Copied!" : "Copy"}>
                        <ContentCopyOutlined
                          style={{
                            float: "right",
                            fontSize: "12px",
                            marginTop: "0px",
                            cursor: "pointer",
                            color: "#406882",
                          }}
                        />
                      </Tooltip>
                      &nbsp;
                      <EmailRounded
                        sx={{ height: "10px", width: "10px", mr: "3px" }}
                      />
                      {selectedJob?.email_id}
                      {(TRUTHY_CONTACT_VALUES.includes(selectedJob?.contact_verified) && selectedJob?.email_id) && (
                        <VerifiedIcon sx={{ color: "#1a8cff", fontSize: 16, ml: 0.5 }} />
                      )}
                    </Typography>
                  </Box>
                  <Paper
                    elevation={1}
                    sx={{
                      position: "absolute",
                      left: "65px",
                      right: 0,
                      top: "28px",
                      padding: "3px",
                      borderRadius: "6px",
                      width: "auto",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <Tooltip
                            title={
                              selectedJob?.contact_name !== "" &&
                                selectedJob.contact_name !== null
                                ? selectedJob.contact_name
                                : ""
                            }
                            followCursor
                          >
                            <Typography
                              paragraph
                              sx={{
                                margin: 0,
                                maxWidth: "170px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontWeight: 800,
                                color: "rgba(0,0,0,0.7)",
                                textTransform: "capitalize",
                                fontSize: "12px",
                              }}
                            >
                              {selectedJob.contact_name !== "" &&
                                selectedJob.contact_name !== null
                                ? selectedJob.contact_name
                                : ""}
                            </Typography>
                          </Tooltip>
                        </Box>
                      </Box>
                      <Box onClick={handleClick}>
                        <img
                          src={LinkedInImage}
                          alt=""
                          width="22px"
                          height="22px"
                          style={{ cursor: "pointer" }}
                        />
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              </CardContent>
            </Card>
          ) : (
            <Card sx={{ mt: 2 }}>Recruiter Details Not Found...</Card>
          )}

          <Divider />
          <Toolbar
            sx={{
              minHeight: "48px !important",
              position: "sticky",

              top: 0,
              zIndex: 3,
              bgcolor: "#fff",
            }}
            style={{ padding: "6px" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {!isSearching ? (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    <IconButton>
                      <CachedIcon onClick={fetchCompanyContacts} />
                    </IconButton>

                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: isDesktopLarge
                          ? "18px"
                          : isDesktopMedium
                            ? "16px"
                            : isDesktopSmall
                              ? "14px"
                              : "13px",
                        margin: 0,
                      }}
                      paragraph
                      id="tableTitle"
                      component="div"
                    >
                      Company Contacts
                    </Typography>
                  </Box>
                  <>
                    <SearchIcon onClick={handleSearchClick} />
                  </>
                </>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    width: "100%",
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search Contact Name"
                    inputProps={{ "aria-label": "search contact name" }}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <>
                    <CloseIcon
                      onClick={handleCloseClick}
                      style={{ fontSize: "20px", color: "#696969" }}
                    />
                  </>
                </Box>
              )}
            </Box>
          </Toolbar>
          <Divider />

          {selectedContact ? (
            <Box
              sx={{
                padding: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <Box sx={{ position: "absolute", right: "10px" }}>
                  <Button
                    title={"Back To Contacts"}
                    onClick={() => setSelectedContact(null)}
                  >
                    <KeyboardBackspaceRounded />
                  </Button>
                </Box>
              </Box>

              <Avatar sx={{ width: 60, height: 60, mb: 2 }}>
                {selectedContact.EMP_CONTACT_NAME?.[0]}
              </Avatar>
              <Typography variant="h6">
                {selectedContact.EMP_CONTACT_NAME}
              </Typography>
              <Box>
                <Typography
                  paragraph
                  sx={{
                    margin: 0,
                    // maxWidth: "0px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    lineHeight: "25px",
                    fontWeight: 800,
                    color: "rgba(0,0,0,0.7)",
                    textTransform: "capitalize",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  {selectedContact?.EMP_DECL_TITLE}
                </Typography>
                <Typography
                  paragraph
                  sx={{
                    margin: 0,
                    // maxWidth: "170px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    lineHeight: "25px",
                    textOverflow: "ellipsis",
                    fontWeight: 800,
                    color: "rgba(0,0,0,0.7)",
                    textTransform: "capitalize",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  Email:{" "}
                  {selectedContact?.EMP_CONTACT_EMAIL
                    ? selectedContact?.EMP_CONTACT_EMAIL
                    : "N/A"}
                </Typography>
                <Typography
                  paragraph
                  sx={{
                    margin: 0,
                    // maxWidth: "170px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    lineHeight: "25px",
                    textOverflow: "ellipsis",
                    fontWeight: 800,
                    color: "rgba(0,0,0,0.7)",
                    textTransform: "capitalize",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  Location:{" "}
                  {selectedContact?.EMP_CONTACT_CITY
                    ? selectedContact?.EMP_CONTACT_CITY
                    : "N/A"}{" "}
                  {selectedContact?.EMP_CONTACT_COUNTRY
                    ? selectedContact?.EMP_CONTACT_COUNTRY
                    : "N/A"}{" "}
                </Typography>

                <Typography
                  paragraph
                  sx={{
                    margin: 0,
                    // maxWidth: "170px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    lineHeight: "25px",
                    textOverflow: "ellipsis",
                    fontWeight: 800,
                    color: "rgba(0,0,0,0.7)",
                    textTransform: "capitalize",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  Phone:{" "}
                  {selectedContact?.EMP_CONTACT_PHONE
                    ? selectedContact?.EMP_CONTACT_PHONE
                    : "N/A"}
                </Typography>

                <Typography
                  paragraph
                  sx={{
                    margin: 0,
                    maxWidth: "280px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontWeight: 800,
                    color: "rgba(0,0,0,0.7)",
                    textTransform: "capitalize",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  <a
                    target="_blank"
                    style={{ color: "rgba(0,0,0,0.7)" }}
                    href={
                      selectedContact?.EMP_LINKEDIN_URL
                        ? selectedContact?.EMP_LINKEDIN_URL
                        : " N /A"
                    }
                  >
                    {selectedContact?.EMP_LINKEDIN_URL
                      ? selectedContact?.EMP_LINKEDIN_URL
                      : "N/A"}
                  </a>
                </Typography>

                {/* Add more details as needed */}
                {/* Message input area */}
                <Box sx={{ alignItems: "center", mt: 2 }}>
                  <TextField
                    id="message-input"
                    label="Type your message"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={3}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Type your message here..."
                  />

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={sendMessage}
                    style={{ marginTop: "10px" }}
                  >
                    Send
                  </Button>
                </Box>
              </Box>
            </Box>
          ) : (
            <>
              <List sx={{ padding: 0 }}>
                {filteredContacts?.length > 0 ? (
                  filteredContacts?.map((contact, index) => (
                    <ListItemButton
                      key={index}
                      sx={{
                        padding: isDesktopLarge ? "10px 20px" : "6px 12px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      onClick={() => setSelectedContact(contact)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box sx={{ width: "50px" }}>
                          <Avatar
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            {contact?.EMP_CONTACT_NAME?.[0]}
                          </Avatar>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 600,
                              margin: 0,
                              width: isDesktopLarge ? "250px" : "150px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {contact?.EMP_CONTACT_NAME}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              margin: 0,
                              width: isDesktopLarge ? "250px" : "150px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {contact?.EMP_DECL_TITLE}
                          </Typography>
                        </Box>
                      </Box>
                    </ListItemButton>
                  ))
                ) : (
                  <Typography
                    variant="body2"
                    sx={{ textAlign: "center", mt: 2 }}
                  >
                    No contacts found.
                  </Typography>
                )}
              </List>
            </>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default InterestedJobsRecruiterDetails;
